import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../../../shared/configurations/configurations.factory';
import { Configurations } from '../../../shared/configurations/models/configurations.model';
import { ApiEnumerationModel } from '../DTOs/base-DTOs/api-enumeration-model.dto';
import { ApiObjectModel } from '../DTOs/base-DTOs/api-object-model.dto';
import { ComuneDto } from '../DTOs/comune.dto';
import { ProvinciaDto } from '../DTOs/provincia.dto';
import { RegioneDto } from '../DTOs/regione.dto';
@Injectable({
  providedIn: 'root'
})
export class ItalianRegistryProxyService {

  private readonly baseUrl: string

  constructor(@Inject(APP_CONFIG) config: Configurations, private readonly httpClient: HttpClient) {
    this.baseUrl = config.environmentConfig.lobbyBaseUrl
  }

  getMunicipalityById$(id: number): Observable<ApiObjectModel<ComuneDto>> {
    return this.httpClient.get<ApiObjectModel<ComuneDto>>(this.baseUrl + `/comune/${id}`)
  }

  getProvinciaById$(id: number): Observable<ApiObjectModel<ProvinciaDto>> {
    return this.httpClient.get<ApiObjectModel<ProvinciaDto>>(this.baseUrl + `/provincia/${id}`)
  }

  getRegioneById$(id: number): Observable<ApiObjectModel<RegioneDto>> {
    return this.httpClient.get<ApiObjectModel<RegioneDto>>(this.baseUrl + `/regione/${id}`)
  }

  searchMunicipality$(pageIndex: number | undefined = undefined,
    pageSize: number | undefined = undefined,
    provinceId: number | undefined = undefined,
    regioneId: number | undefined = undefined,
    name: string | undefined = undefined,
    cap: string | undefined = undefined,
    includeIntactive: boolean | undefined = undefined
  ) {

    let query: string = '';

    if (pageIndex) query = query + `${query ? '&' : ''}pg_ix=${pageIndex}`
    if (pageSize) query = query + `${query ? '&' : ''}pg_sz=${pageSize}`
    if (provinceId) query = query + `${query ? '&' : ''}provinciaId=${provinceId}`
    if (regioneId) query = query + `${query ? '&' : ''}regioneId=${regioneId}`
    if (name) query = query + `${query ? '&' : ''}nome=${name}`
    if (cap) query = query + `${query ? '&' : ''}cap=${cap}`
    if (includeIntactive) query = query + `${query ? '&' : ''}includeIntactive=${includeIntactive}`

    return this.httpClient.get<ApiEnumerationModel<ComuneDto>>(this.baseUrl + `/comune` + `${query ? '?' : ''}${query}`)
  }

  searchProvincia$(pageIndex: number | undefined = undefined,
    pageSize: number | undefined = undefined,
    regioneId: number | undefined = undefined,
    name: string | undefined = undefined,
    sigla: string | undefined = undefined
  ) {

    let query: string = '';

    if (pageIndex) query = query + `${query ? '&' : ''}pg_ix=${pageIndex}`
    if (pageSize) query = query + `${query ? '&' : ''}pg_sz=${pageSize}`
    if (regioneId) query = query + `${query ? '&' : ''}regioneId=${regioneId}`
    if (name) query = query + `${query ? '&' : ''}nome=${name}`
    if (sigla) query = query + `${query ? '&' : ''}cap=${sigla}`

    return this.httpClient.get<ApiEnumerationModel<ProvinciaDto>>(this.baseUrl + `/provincia` + `${query ? '?' : ''}${query}`)
  }

  searchRegione$(pageIndex: number | undefined = undefined,
    pageSize: number | undefined = undefined,
    name: string | undefined = undefined
  ) {

    let query: string = '';

    if (pageIndex) query = query + `${query ? '&' : ''}pg_ix=${pageIndex}`
    if (pageSize) query = query + `${query ? '&' : ''}pg_sz=${pageSize}`
    if (name) query = query + `${query ? '&' : ''}nome=${name}`

    return this.httpClient.get<ApiEnumerationModel<RegioneDto>>(this.baseUrl + `/regione` + `${query ? '?' : ''}${query}`)
  }
}
